import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { NzResizeEvent } from "ng-zorro-antd/resizable";
import {
  VAIconRegistryService,
  ellipsisVertical,
} from "@va/core-library/icons";
import { FacetFilter, NoDataMsg, extraInfoKeys } from "../pharma-page.model";
import { FilterEventChanged } from "src/app/store/actions/pharma-page.actions";
import { faEllipsisV } from "@fortawesome/pro-solid-svg-icons";
import { Subscription } from "rxjs";
import { PharmaDataService } from "../pharma-data.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NzMessageService } from "ng-zorro-antd/message";
@Component({
  selector: "app-database-page",
  templateUrl: "./database-page.component.html",
  styleUrls: ["./database-page.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DatabasePageComponent implements OnInit, OnDestroy {
  chartFilters: any;
  facetFilters: any;
  auditFormulabarVisible = false;
  columnList = [];
  siderWidth = 343;
  collapsedWidth = 48;
  faEllipsisV = faEllipsisV;
  id = -1;
  panel = {
    active: true,
    name: "Chart filters",
    disabled: false,
  };
  facetChangeSubscriber: Subscription;
  defaultFilterName = "My Filter";
  selectedSavedFilter: {
    filter_name: string;
    filter_id: number;
    json_data: any;
  };
  collapsedSider = false;
  routeSubscriber: Subscription;
  getSavedFilterSubscriber: Subscription;
  dpCallSubscriber: Subscription;
  auditSourceData: any = {};

  changeCollapseValue($event) {
    this.collapsedSider = $event;
  } //will be triggered by child via Output() EventEmitter

  toggleSiderFromParent() {
    this.collapsedSider = !this.collapsedSider;
  }
  onSideResize({ width }: NzResizeEvent): void {
    cancelAnimationFrame(this.id);
    this.id = requestAnimationFrame(() => {
      this.siderWidth = width!;
    });
  }

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private service: PharmaDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([ellipsisVertical]);
  }

  ngOnInit() {
    this.routeSubscriber = this.route.queryParamMap.subscribe(() => {
      const param = this.route.snapshot.params;
      if (param.pageContext) {
        const queryParams = this.route.snapshot.queryParams;
        if (
          param.pageContext === "user" &&
          queryParams &&
          queryParams.filterId
        ) {
          const selectedFilterId = parseInt(
            decodeURIComponent(queryParams.filterId),
          );
          this.getSavedFilterSubscriber = this.service
            .getSavedFilterObject(selectedFilterId)
            .subscribe((resp) => {
              if (resp.status === "success" && resp.data.length > 0) {
                this.selectedSavedFilter = {
                  filter_id: resp.data[0].filter_id,
                  filter_name: resp.data[0].filter_name,
                  json_data: resp.data[0].json_data,
                };
                let facetFilter = new FacetFilter();
                facetFilter = FacetFilter.fromJson(
                  this.selectedSavedFilter.json_data,
                );
                this.chartFilters = {
                  company_id: "",
                  therapeutic_area: "",
                  indication: "",
                  moa: "",
                  phase: "",
                };
                this.facetFilters = facetFilter.toDTO();
                //Avoid race condition between this block and setDefaultGridSettings
                this.store.dispatch(
                  new FilterEventChanged({
                    filterChanged: "facet",
                    source: "saved-filter",
                    data: {
                      facetFilters: this.facetFilters,
                      savedFilter: this.selectedSavedFilter,
                      extraInfo: this.service.getPharmaStateExtraInfo(
                        extraInfoKeys,
                        {},
                      ),
                      fromQueryFilter: true,
                    },
                  }),
                );
              } else {
                this.message.error(resp.message ? resp.message : NoDataMsg);
                this.router.navigate([`/biopharma/database`]);
              }
            });
        } else if (
          param.pageContext === "peers" &&
          queryParams &&
          queryParams.peerId &&
          queryParams.ctagId
        ) {
          const ctagId = queryParams.ctagId;
          const peerId = queryParams.peerId;

          if (
            peerId === "indication" ||
            peerId === "moa" ||
            peerId === "api" ||
            peerId === "target"
          ) {
            this.service
              .getDrugOverallSummary(ctagId)
              .subscribe((resp: any) => {
                if (resp.status === "success") {
                  let peerData = [];
                  if (peerId === "indication") {
                    peerData = resp.data.indication_by_phase.map((indPhase) => {
                      return indPhase.indication;
                    });
                  } else {
                    peerData = resp.data[peerId];
                  }

                  this.chartFilters = {
                    company_id: "",
                    therapeutic_area: "",
                    indication: "",
                    moa: "",
                    phase: "",
                    target: "",
                    commercial_status: "",
                  };
                  this.facetFilters = new FacetFilter().toDTO();
                  const extraInfo = {
                    [`${peerId}_data`]: {},
                  };
                  for (let i = 0; i < peerData.length; i++) {
                    this.facetFilters[peerId].push(
                      resp.data.values_mtag_map[peerData[i]],
                    );
                    extraInfo[`${peerId}_data`][
                      resp.data.values_mtag_map[peerData[i]]
                    ] = peerData[i];
                  }
                  this.selectedSavedFilter = {
                    filter_id: null,
                    filter_name: "",
                    json_data: this.facetFilters,
                  };
                  this.store.dispatch(
                    new FilterEventChanged({
                      filterChanged: "facet",
                      source: "default",
                      data: {
                        facetFilters: this.facetFilters,
                        extraInfo: this.service.getPharmaStateExtraInfo(
                          extraInfoKeys,
                          extraInfo,
                        ),
                        savedFilter: {
                          filter_id: null,
                          filter_name: "",
                          json_data: {},
                        },
                      },
                    }),
                  );
                } else {
                  console.error(
                    "Drug overall summary api call did not succeed",
                  );
                  this.router.navigate([`/biopharma/database`]);
                }
              });
          } else {
            console.error("Invalid peer id");
            this.router.navigate([`/biopharma/database`]);
          }
        } else if (param.pageContext === "filter" && queryParams) {
          try {
            this.chartFilters = {
              company_id: "",
              therapeutic_area: "",
              indication: "",
              moa: "",
              phase: "",
            };
            const facetObj = {};
            for (const key in queryParams) {
              const val = queryParams[key] ? queryParams[key].trim() : null;
              if (val) {
                if (key === "include_terminated") {
                  facetObj[key] = Boolean(val);
                } else {
                  facetObj[key] = [parseInt(val)];
                }
              } else {
                facetObj[key] = [];
              }
            }

            const facets = FacetFilter.fromJson(facetObj);
            this.facetFilters = facets.toDTO();

            this.selectedSavedFilter = {
              filter_id: null,
              filter_name: "",
              json_data: this.facetFilters,
            };
            this.store.dispatch(
              new FilterEventChanged({
                filterChanged: "facet",
                source: "default",
                data: {
                  facetFilters: this.facetFilters,
                  extraInfo: this.service.getPharmaStateExtraInfo(
                    extraInfoKeys,
                    {},
                  ),
                  fromQueryFilter: true,
                  savedFilter: {
                    filter_id: null,
                    filter_name: "",
                    json_data: {},
                  },
                },
              }),
            );
          } catch (e) {
            console.error("Error while converting company id to int");
            this.router.navigate([`/biopharma/database`]);
          }
        } else {
          console.error("invalid page context");
          this.message.error("Invalid page context");
          this.router.navigate([`/biopharma/database`]);
        }
      } else {
        this.chartFilters = {
          company_id: "",
          therapeutic_area: "",
          indication: "",
          moa: "",
          phase: "",
        };
        this.facetFilters = new FacetFilter().toDTO();
        this.selectedSavedFilter = {
          filter_id: null,
          filter_name: "",
          json_data: this.facetFilters,
        };
        this.store.dispatch(
          new FilterEventChanged({
            filterChanged: "facet",
            source: "default",
            data: {
              facetFilters: this.facetFilters,
              extraInfo: this.service.getPharmaStateExtraInfo(
                extraInfoKeys,
                {},
              ),
              savedFilter: {
                filter_id: null,
                filter_name: "",
                json_data: {},
              },
            },
          }),
        );
        //Avoid race condition between this block and setDefaultGridSettings
        // if (this.gridSettings && this.gridSettings.options) {
        //   this.gridSettings.options.filter = this.facetFilters.toDTO();
        //   this.gridSettings = { ...this.gridSettings };
        // }
      }
    });

    this.setSubheaderTitle();
    this.dpCallSubscriber = this.service.dpClicked.subscribe(
      ({ selectedCell, auditCols }) => {
        if (!selectedCell) return;
        const colName = selectedCell.substring(selectedCell.indexOf("|") + 1);
        this.formulabarVisible(
          selectedCell && colName !== -1 && auditCols.indexOf(colName) !== -1,
        );
      },
    );
  }
  formulabarVisible(isVisible) {
    this.auditFormulabarVisible = isVisible;
  }
  chartFilterChanged(data) {
    this.chartFilters = { ...data };
  }
  setSubheaderTitle() {
    this.store.dispatch(
      new GlobalSubheaderActions.SubheaderTitleChanged({
        title: "BioPharma",
        sup: "",
        link: "",
      }),
    );
  }

  ngOnDestroy() {
    if (this.facetChangeSubscriber) {
      this.facetChangeSubscriber.unsubscribe();
    }
    if (this.routeSubscriber) {
      this.routeSubscriber.unsubscribe();
    }
    if (this.getSavedFilterSubscriber) {
      this.getSavedFilterSubscriber.unsubscribe();
    }
    if (this.dpCallSubscriber) {
      this.dpCallSubscriber.unsubscribe();
    }
  }
}
